var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.58756 1.48625C7.78617 1.19646 8.21383 1.19646 8.41244 1.48625L10.5606 4.62064C10.7556 4.90524 11.0428 5.1139 11.3738 5.21145L15.0186 6.28587C15.3555 6.38521 15.4877 6.79194 15.2735 7.07037L12.9563 10.082C12.7459 10.3554 12.6362 10.693 12.6457 11.0379L12.7501 14.8363C12.7598 15.1875 12.4138 15.4389 12.0828 15.3212L8.50257 14.048C8.1775 13.9324 7.8225 13.9324 7.49743 14.048L3.9172 15.3212C3.58619 15.4389 3.2402 15.1875 3.24986 14.8363L3.35433 11.0379C3.36382 10.693 3.25412 10.3554 3.04372 10.082L0.726548 7.07037C0.512316 6.79194 0.644472 6.38521 0.981446 6.28587L4.62625 5.21145C4.95719 5.1139 5.24438 4.90524 5.43942 4.62064L7.58756 1.48625Z","stroke":"#3F3F3F"}));
}

Star.defaultProps = {"style":{"marginBottom":"0.2em"},"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Star;

Star.default = Star;
